
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare",
      function () {
        return require("private-next-pages/medicare.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare"])
      });
    }
  